export const essenHund = new Audio('assets/sounds/essen.mp3');
export const bellen1Hund = new Audio('assets/sounds/bellen1.mp3');
export const halloHund = new Audio('assets/sounds/begruessung.mp3');
export const japsenHund = new Audio('assets/sounds/japsen.mp3');
export const schnarchenHund = new Audio('assets/sounds/schnarchen.mp3');
export const schwanzwedelnHund = new Audio('assets/sounds/schwanzwedeln.mp3');
export const spielenHund = new Audio('assets/sounds/spielen.mp3');
export const trinkenHund = new Audio('assets/sounds/trinken.mp3');
export const wimmernHund = new Audio('assets/sounds/wimmern.mp3');
export const parkHund = new Audio('assets/sounds/park.mp3');
export const quietschenHund = new Audio('assets/sounds/quietschen.mp3');

export const trockenfutter = new Audio('assets/sounds/essen-trockenfutter.mp3');
export const trockenfutter2 = new Audio('assets/sounds/trockenfutter2.mp3');
export const wecker = new Audio('assets/sounds/wecker.mp3');
export const fegen = new Audio('assets/sounds/fegen.mp3');
export const fegen2 = new Audio('assets/sounds/fegen3.mp3');
export const bubble = new Audio('assets/sounds/bubble-pop.mp3');

export const halloKatze = new Audio('assets/sounds/halloKatze.mp3');
export const jammern2Katze = new Audio('assets/sounds/jammern2Katze.mp3');
export const mauzenKatze = new Audio('assets/sounds/mauzenKatze.mp3');
export const schnurrenKatze = new Audio('assets/sounds/schnurrenKatze.mp3');
export const spielenKatze = new Audio('assets/sounds/spielenKatze.mp3');
export const spielen2Katze = new Audio('assets/sounds/spielen2Katze.mp3');
export const spielen3Katze = new Audio('assets/sounds/spielen3Katze.mp3');
export const wasserKatze = new Audio('assets/sounds/wasserKatze.mp3');
export const essenKatze = new Audio('assets/sounds/essenKatze.mp3');
export const schnarchenKatze = new Audio('assets/sounds/schnarchenKatze.mp3');


export const allSounds: HTMLAudioElement[] = [
  essenHund, trockenfutter, japsenHund, schnarchenHund, spielenHund,
  trinkenHund, bellen1Hund, halloHund, schwanzwedelnHund, wimmernHund, parkHund, quietschenHund,
  fegen, wecker, fegen2, bubble,
  halloKatze, mauzenKatze, schnurrenKatze, spielenKatze, essenKatze,
  spielen2Katze, wasserKatze, schnarchenKatze, spielen3Katze, jammern2Katze
];
